import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { forwardRef } from "react";
import { margin, color } from "styled-system";
import styled, { css } from "styled-components";
import Flex from "../flex";
import { isNumber } from "../../utils/type-util";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getSizeStyle(size) {
  return css(["width:", "px;height:", "px;min-width:", "px;min-height:", "px;line-height:", "px;font-size:", "px;"], size, size, size, size, size, size / 2);
}
const AvatarRoot = styled(AvatarPrimitive.Root).withConfig({
  displayName: "avatar__AvatarRoot",
  componentId: "sc-1wafy6k-0"
})(["position:relative;display:inline-flex;align-items:center;justify-content:center;vertical-align:middle;white-space:nowrap;text-align:center;overflow:hidden;user-select:none;width:32px;height:32px;font-size:16px;font-weight:500;border-radius:", ";background:", ";color:#fff;", " ", " ", " ", " ", ""], p => p.shape === "square" ? `${p.theme.radii.base}px` : "50%", p => p.theme.colors.gray[4], margin, color, p => p.size === "small" && getSizeStyle(24), p => p.size === "large" && getSizeStyle(40), p => isNumber(p.size) && getSizeStyle(p.size));
const AvatarImage = styled(AvatarPrimitive.Image).withConfig({
  displayName: "avatar__AvatarImage",
  componentId: "sc-1wafy6k-1"
})(["width:100%;height:100%;object-fit:cover;border-radius:inherit;background:transparent;"]);
const AvatarFallback = styled(AvatarPrimitive.Fallback).withConfig({
  displayName: "avatar__AvatarFallback",
  componentId: "sc-1wafy6k-2"
})(["width:100%;height:100%;display:flex;align-items:center;justify-content:center;text-transform:uppercase;"]);
export const AvatarGroup = styled(Flex).withConfig({
  displayName: "avatar__AvatarGroup",
  componentId: "sc-1wafy6k-3"
})(["display:inline-flex;", "{border:1px solid ", ";&:not(:first-child){margin-left:-8px;}}"], AvatarRoot, p => p.theme.colors.bg.component);
export const Avatar = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    src,
    alt,
    delayMs,
    size = "default",
    shape = "circle",
    color,
    onLoadingStatusChange,
    fallback,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(AvatarRoot, {
    ref: ref,
    ...rest,
    size: size,
    shape: shape,
    color: color,
    children: [/*#__PURE__*/_jsx(AvatarImage, {
      src: src,
      alt: alt,
      onLoadingStatusChange: onLoadingStatusChange
    }), /*#__PURE__*/_jsx(AvatarFallback, {
      delayMs: delayMs,
      children: fallback
    })]
  });
});
export default Object.assign(Avatar, {
  Group: AvatarGroup
});